var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import './styles.css';
import { WalletModalContext } from './useWalletModal';
import { WalletModal } from './WalletModal';
export const WalletModalProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const [visible, setVisible] = useState(false);
    return (React.createElement(WalletModalContext.Provider, { value: {
            visible,
            setVisible,
        } },
        children,
        visible && React.createElement(WalletModal, Object.assign({}, props))));
};
//# sourceMappingURL=WalletModalProvider.js.map